var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_vm.$options.components['advertisement-loading'] ? [_vm.isLoading ? _c('advertisement-loading') : _vm._e()] : _vm._e(), !_vm.isLoading ? _c('b-row', [_c('b-col', {
    staticClass: "my-4"
  }, [_c('div', {
    staticClass: "main-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.physiotherapistBanner.icon && _vm.physiotherapistBanner.icon.fileUrl || '',
      "alt": "Physiotherapist Center Top Banner"
    }
  })]), _c('div', [_c('b-row', {
    staticClass: "my-4"
  }, _vm._l(_vm.physiotherapistCategory, function (physio) {
    return _c('b-col', {
      key: physio.category,
      attrs: {
        "md": "4"
      }
    }, [_c('div', {
      staticClass: "physio-category",
      style: {
        backgroundImage: 'url(' + physio.backgroundImage + ')'
      },
      on: {
        "click": function ($event) {
          return _vm.physioCategoryClick(physio.category);
        }
      }
    }, [_c('p', [_vm._v(_vm._s(physio.category))])])]);
  }), 1)], 1), _c('div', [_c('b-container', [_vm.$options.components['advertisement-bottom-banner'] ? [_c('advertisement-bottom-banner')] : _vm._e()], 2)], 1), _c('div', {
    staticClass: "main-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.physiotherapistBanner.icon && _vm.physiotherapistBanner.icon.fileUrl || '',
      "alt": "Diagnostic Center Top Banner"
    }
  })])])], 1) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }